import React from "react"
import SpriteAnimator from "../../design_system/core/hooks/use_sprite_animation/component"

export default (props, railsContext) => {
  return () => <SpriteAnimator {...props} />
}
